module.exports = __webpack_public_path__ + "img/8step-02-02-1_ergebnis.65296c22.png";